const JIRA_ISSUE_KEY_IN_URL = /\/browse\/([A-Za-z][A-Za-z0-9_]*-\d+)/;
export const getJiraIssueIdentifier = (url) => {
    try {
        const { pathname } = new URL(url);
        return pathname.match(JIRA_ISSUE_KEY_IN_URL)?.[1] ?? null;
    }
    catch {
        return null;
    }
};
//# sourceMappingURL=jira.js.map